import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OfferCardSubtype, OfferCardType } from '../../offer-card-data.model';
import { AbstractOfferCard } from '../abstract-offer-card.component';

@Component({
  selector: 'basic-offer-card',
  template: `
    <offer-card
      [moduleId]="moduleId"
      [moduleIndex]="moduleIndex"
      [uniqueId]="uniqueId"
      [positionIndex]="positionIndex"
      [data]="data"
      [currency]="currency"
      [locale]="locale"
      [loyaltyMode]="loyaltyMode"
      [flow]="flow"
      [product]="product"
      [sboxAutocomplete]="sboxAutocomplete"
      [offerCardType]="offerCardType"
      [moduleReferer]="moduleReferer"
    >

      <offer-image 
        *ngIf="data.picture_link" offer-image
        [mediaKey]="data.picture_link" [product]="product"
        [alt]="data.product_text + ' - ' + data.main_text"
      ></offer-image>

      <offer-multiple-image 
        *ngIf="data.pictures_carrousel && !data.picture_link" offer-image
        [mediaKeys]="data.pictures_carrousel"
        [alt]="data.product_text + ' - '+ data.main_text"
      ></offer-multiple-image>
      <div *ngIf="hasDriversToShow()" class="basic-offer-card-top-driver" driver>
        <outstanding-driver *ngIf="data.mealplans_driver" [outstandingDriverData]="data.mealplans_driver"></outstanding-driver>
        <outstanding-driver *ngIf="!data.mealplans_driver && getUnbeatableDriver()" [outstandingDriverData]="getUnbeatableDriver()!"></outstanding-driver>
        <img *ngIf="this.data.offer_card_subtype === 'MULTIDESTINATION_MULTIPRODUCT' && isWowOffer()"
            src="https://s3.staticontent.com/67f50ade/2.24.9/assets/images/offers-wow-cluster-ribbon-default.svg"
            class="wow-image"
            loading="lazy"
            alt="Wow Image">
      </div>
      
      <ng-container offer-content>
        <outstanding-driver *ngIf="this.data.outstanding_driver" [outstandingDriverData]="this.data.outstanding_driver"></outstanding-driver>
        
        <div class="basic-offer-title-container">
          <review-score *ngIf="data.overall_rating && isPackageSingleDestination()" [score]="data.overall_rating" [size]="'-sm'"></review-score>
          <h5 class="basic-offer-card-title" [ngClass]="isPackageSingleDestination() ? '-one-line' : ''">{{data.main_text}}</h5>
        </div>
        <div *ngIf="data.overall_rating || data.small_text" class="basic-offer-card-rating">
          <review-score *ngIf="!isPackageSingleDestination()" [score]="data.overall_rating" [size]="'-sm'"></review-score>
          <span class="basic-offer-card-small-text">{{data.small_text}}</span>
          <span *ngIf="data.stars || data.product_text || data.dates " class="basic-offer-card-rating-separator"></span>
          <div class="basic-offer-card-rating-stars" *ngIf="data.stars">
            <i *ngFor="let star of stars" class="-eva-3-icon-xsm eva-3-icon-star-filled"></i>
          </div>

          <div *ngIf="data.product === VACATION_RENTALS && !data.stars"  >
            <span class="basic-offer-card-product">{{data.product_text}}</span>
          </div>
          <ng-container *ngIf="data.dates">
            <span class="basic-offer-card-dates">{{data.dates.from?.text}}</span>
            <span class="basic-offer-card-separator"> - </span>
            <span class="basic-offer-card-dates">{{data.dates.to?.text}}</span>
          </ng-container>
        </div>
      </ng-container>
    </offer-card>
  `,
  styleUrls: ['./basic-offer-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BasicOfferCardComponent extends AbstractOfferCard implements OnInit {
  readonly offerCardType = OfferCardType.BASIC;
  readonly VACATION_RENTALS = 'vacation_rentals';

  @Input() sboxAutocomplete?: boolean;

  stars: Array<string> = [];

  ngOnInit(): void {
    this.initStars();
  }

  private initStars(): void {
    if (this.data.stars) {
      this.stars = new Array(Number(this.data.stars)).fill({});
    }
  }

  getUnbeatableDriver() {
    const priorityTypes = ['UNBEATABLE', 'BASE'];
    return this.data.drivers?.find(driver => priorityTypes.includes(driver.type));
  }

  hasDriversToShow(): boolean {
    return !!(this.data.mealplans_driver || this.getUnbeatableDriver() || this.isWowOffer());
  }

  isWowOffer(): boolean {
    return !!(this.data.pictures_carrousel && this.data.pictures_carrousel.length > 0);
  }

  isPackageSingleDestination(): boolean {
    return this.data.offer_card_subtype === OfferCardSubtype.SINGLE_DESTINATION_SINGLE_PRODUCT
       && (this.data.offer_type === 'PACKAGES' || this.data.product === 'packages');
  }

}
